export default __webpack_public_path__ + "c5449df1175c4942da383367ce13af89.png";